import { __rest } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { getStyle } from './utils.es.js';
import styled from '@emotion/styled';
import { ThemeProvider, Global } from '@emotion/react';
import { defaultTheme, LandingLinks, reset } from './constants.es.js';

const Wrapper$1 = styled.div(({ commonStyle }) => `
    min-height: 100vh;
    @media (max-width: 767px) {
      .hidden-xs {
        display: none !important;
      }
    }

    @media (min-width: 768px) {
      .hidden-md {
        display: none !important;
      }
    }
    ${getStyle(commonStyle)};
  `);
const Root = forwardRef((props, ref) => {
    const { children } = props, rest = __rest(props, ["children"]);
    return (jsxs(ThemeProvider, Object.assign({ theme: defaultTheme }, { children: [jsx(LandingLinks, {}), jsx(Global, { styles: reset }), jsx(Wrapper$1, Object.assign({}, rest, { ref: ref }, { children: children }))] })));
});
Root.displayName = 'Root';

const Wrapper = styled.div `
  position: absolute;
  width: 0;
  height: 0;
`;
const PopupRoot = forwardRef((props, ref) => {
    const { children } = props;
    return (jsxs(ThemeProvider, Object.assign({ theme: defaultTheme }, { children: [jsx(LandingLinks, {}), jsx(Global, { styles: reset }), jsx(Wrapper, Object.assign({ ref: ref }, { children: children }))] })));
});
PopupRoot.displayName = 'PopupRoot';

export { PopupRoot as P, Root as R };
